import type {
	SettingsTemplateModel,
	SettingsTemplateType,
} from '@/shared/generated'

import { useMemo } from 'react'
import { PuzzleIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { useModals } from '@/shared/lib/modal-manager'

export const useUseTemplateAction = ({
	templateType,
	handler,
}: {
	templateType: SettingsTemplateType
	handler: (template: SettingsTemplateModel) => void
}) => {
	const { t } = useTranslation()

	const { showModal } = useModals()

	return useMemo(
		() => ({
			key: 'use_template',
			label: t('settings.action.use_template', {
				defaultValue: 'Use template',
			}),
			icon: <PuzzleIcon className='size-4' />,
			onClick: () => {
				showModal('SETTING_TEMPLATES_MODAL', {
					template_types: [templateType],
					handleApply: handler,
				})
			},
			testId: 'template-action-use-template',
		}),
		[handler, templateType, showModal]
	)
}
